module.exports = __webpack_public_path__ + "static/Easter2022-b9efe3d223a637881982e6875671a640.jpg";